import { render, staticRenderFns } from "./AppExplain.vue?vue&type=template&id=054db666&scoped=true&"
import script from "./AppExplain.vue?vue&type=script&lang=js&"
export * from "./AppExplain.vue?vue&type=script&lang=js&"
import style0 from "./AppExplain.vue?vue&type=style&index=0&id=054db666&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "054db666",
  null
  
)

export default component.exports